import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="global.cta.trial-no" defaultMessage="Subscribe" />;
